import CheckIcon from "material-ui/svg-icons/action/check-circle";
import ArchiveIcon from "material-ui/svg-icons/content/archive";
import PdfIcon from "material-ui/svg-icons/image/picture-as-pdf";
import SyncIcon from "material-ui/svg-icons/notification/sync";
import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import AuthService from "../../../services/AuthService";

class LoginPage extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      pwd: "",
      redirectToReferrer: false,
      errMsgDisplay: "none",
    };
    this.login = this.login.bind(this);
    this.Auth = new AuthService();
    this.getLoginDestination = this.getLoginDestination.bind(this);
  }

  login(event) {
    event.preventDefault();
    this.Auth.login(this.state.email, this.state.pwd)
      .then((resp) => {
        this.setState({ redirectToReferrer: true });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.payload)
          console.error(err.response.data.payload);
        this.setState({ errMsgDisplay: "block" });
      });
  }

  getLoginDestination() {
    if (this.props.location.state) {
      console.log("rederiction to referrer: ", this.props.location.state);
      return this.props.location.state;
    } else {
      let userType = this.Auth.getProfile()
        ? this.Auth.getProfile().data.userType
        : "";
      switch (userType) {
        case "societe":
          console.log("Login-in as : ENTREPRISE");
          return { from: { pathname: "/entreprise" } };
        case "salarie":
          console.log("Login-in as : SALARIE");
          return { from: { pathname: "/salarie" } };
        case "admin":
          console.log("Login-in as : ADMIN");
          return { from: { pathname: "/admin" } };
        default:
          return { from: { pathname: "/" } };
      }
    }
  }

  render() {
    const { redirectToReferrer } = this.state;
    const { from } = this.getLoginDestination();
    if (redirectToReferrer) {
      return <Redirect to={from} />;
    }
    return (
      <div className="App">
        <div className="header" style={{ backgroundColor: "#007bff" }}>
          <div className="container">
            <div className="row">
              <h1 className="col-md-6 col-sm-12" id="head-left-title">
                MonEntretien<span className="blue">PRO</span>
              </h1>
              <div className="col-md-6 col-sm-12">
                <form className="row" onSubmit={this.login}>
                  <div className="col">
                    <input
                      type="email"
                      autoComplete={"current-email"}
                      onChange={(e) => this.setState({ email: e.target.value })}
                      value={this.state.email}
                      className="transparent-input"
                      placeholder="Email"
                      required
                    />
                  </div>
                  <div className="col">
                    <input
                      type="password"
                      autoComplete={"current-password"}
                      onChange={(e) => this.setState({ pwd: e.target.value })}
                      value={this.state.pwd}
                      className="transparent-input"
                      placeholder="Mot de passe"
                      required
                    />
                  </div>
                  <div className="col with-margin">
                    <button type="submit" className="btn btn-primary">
                      Connexion
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div
              className={"row"}
              style={{ display: this.state.errMsgDisplay }}
            >
              <div
                className="col alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                <strong>Erreur :</strong> Votre email ou mot de passe n'est pas
                correct.
                <br />
                <Link to={"/recup_mot_de_passe"}>Mot de passe oublié</Link>
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div className="row">
              <h2 className="col text-center" id="header-big-text">
                La gestion de vos entretiens
                <br /> n'a jamais été aussi facile.
              </h2>
            </div>
            <div className="row">
              <div className="col text-center" id="header-note">
                Inscrivez-vous maintenant pour bénéficier des meilleurs tarifs
              </div>
            </div>
            <div className="row" id="header-inscription">
              <div className="col text-center">
                <Link
                  role="button"
                  to="/inscription"
                  className="btn btn-lg btn-primary"
                >
                  Découvrez L'application
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid" id="offer-details">
          <div className="row">
            <div className="col text-center">
              <h1 className="offer-x-title">
                La solution simple et sécurisée pour réaliser les entretiens
                professionnels.
              </h1>
            </div>
          </div>
          <div className="row">
            <div className="col text-center a">
              <div id="detail-a">
                <CheckIcon style={{ width: 80, height: 80 }} />
                <br />
                <label className="offer-detail-sub-title">Facilité</label>
                <p>
                  Réalisez un entretien professionnel pas à pas en toute
                  facilité.
                </p>
              </div>
            </div>
            <div className="col text-center b">
              <div id="detail-b">
                <SyncIcon style={{ width: 80, height: 80 }} />
                <br />
                <label className="offer-detail-sub-title">
                  Collaborativité
                </label>
              </div>
              <p>
                Vos salariés participent dans la préparation de leurs entretiens
                et expriment leurs intentions professionnelles.
              </p>
            </div>
            <div className="col text-center c">
              <div id="detail-c">
                <ArchiveIcon style={{ width: 80, height: 80 }} />
                <br />
                <label className="offer-detail-sub-title">Archivage</label>
              </div>
              <p>
                L'enssemble des entretiens que vous passez à vos salariés sont
                archivés en toute sécurité.
              </p>
            </div>
            <div className="col text-center d">
              <div id="detail-d">
                <PdfIcon style={{ width: 80, height: 80 }} />
                <br />
                <label className="offer-detail-sub-title">Synthèses</label>
              </div>
              <p>
                Des synthèses sont générées automatiquement pour justifier le
                respect vos obligations salariales.
              </p>
            </div>
          </div>
        </div>

        <div className="container-fluid" id="offer-steps">
          <div className="row">
            <div className="col text-center">
              <h1 className="offer-x-title">Une expérience en 4 étapes.</h1>
            </div>
          </div>
          <div className="row">
            <div className="col text-center ">
              <span
                style={{ fontSize: 18 }}
                className="badge badge-pill badge-primary step-title"
              >
                1 Inscription
              </span>
              <p>
                Vous ajoutez vos salariés via le formulaire d'ajout ou en
                important un fichier Excel.
              </p>
            </div>
            <div className="col text-center ">
              <span
                style={{ fontSize: 18 }}
                className="badge badge-pill badge-primary step-title"
              >
                2 Convocation
              </span>
              <p>
                Via un formulaire de convocation vous pouvez prévenir vos
                salariés pour un futur entretien, ces derniers seront notifiés
                par email.
              </p>
            </div>
            <div className="col text-center ">
              <span
                style={{ fontSize: 18 }}
                className="badge badge-pill badge-primary step-title"
              >
                3 Préparatifs
              </span>
              <p>
                Sur son espace personnel le salarié peut préparer l'entretien et
                préciser ses souhaits professionnels.
              </p>
            </div>
            <div className="col text-center ">
              <span
                style={{ fontSize: 18 }}
                className="badge badge-pill badge-primary step-title"
              >
                4 Export
              </span>
              <p>
                L'entreprise et le salarié peuvent télécharger les fiches
                d'entretiens ainsi que les différentes synthèses.
              </p>
            </div>
          </div>
        </div>

        <div className="container-fluid" id="registration">
          <div className="row">
            <div className="col text-center offer-x-title">
              Inscrivez-vous et profitez au plus vite de l'offre promotionnelle.
            </div>
          </div>
          <div className="row">
            <div className="col text-center">
              <Link
                role="button"
                to="/inscription"
                className="btn btn-lg btn-primary"
              >
                Découvrez L'application
              </Link>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col text-center" />
          </div>
        </div>

        <footer className="footer">
          <div className="container">
            <div className="row">
              <div className="col footer-section">
                <h3 className="footer-title">MonEntretienPRO © 2019</h3>
              </div>
              <div className="col footer-section">
                <h3 className="footer-title">Plan du site</h3>
                <Link to="/last-posts">Derniers articles</Link>
                <br />
                <Link to="/inscription">Inscription</Link>
                <br />
                <Link to={"/recup_mot_de_passe"}>Mot de passe oublié</Link>
              </div>
              <div className="col footer-section">
                <h3 className="footer-title">Partenaires</h3>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.transcendis.fr/"
                >
                  Transcendis
                </a>
              </div>
              <div className="col footer-section">
                <h3 className="footer-title">Nous contacter</h3>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="mailto:transcendis@hotmail.fr"
                >
                  transcendis@hotmail.fr
                </a>
              </div>
              <div className="col footer-section">
                <h3 className="footer-title">Développé par</h3>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://frenchtechlead.com/"
                >
                  FrenchTechLead
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/components/shared/pages/LoginPage.js